import type { ComponentType } from "react";
import type { LevelView } from "@nabla/api";
import { entrypoint, viewOf, type PlaceFacts, type ViewProps } from "../../client/index.ts";
import { designCopy } from "../../design/copy.ts";

const levelExploration = ["dias", "ordem", "pagina"];

function levelQuery(search: URLSearchParams) {
  return { dias: search.get("dias") ?? undefined, ordem: search.get("ordem") ?? undefined, pagina: search.get("pagina") ?? undefined };
}

function levelPlace(data: LevelView): PlaceFacts {
  return { title: data.ref.name, self: data.ref, path: data.path, siblings: data.siblings, managerUrl: data.managerUrl };
}

type Level = "campanha" | "conjunto" | "anuncio";
type View = () => Promise<{ readonly default: ComponentType<ViewProps<LevelView>> }>;

export function levelEntry(level: Level, view: View, missing?: () => string) {
  const read = viewOf(level);
  return entrypoint({
    id: level,
    path: `/${level}/:id`,
    level,
    replaceOn: levelExploration,
    data: ({ id }, search) => read({ id }, levelQuery(search)),
    view,
    place: levelPlace,
    morph: ({ id }) => `obj-${id}`,
    ...(missing === undefined ? {} : { missing }),
  });
}

export const entrypoints = [levelEntry("campanha", () => import("./view.tsx"), () => designCopy.lugares.campanhaFora)];
